module.exports = __webpack_public_path__ + "img/nueva-vida-espana-cohen-y-aguirre.5ed1b88e.jpg";